import React, { useMemo } from 'react';
import { Popover } from 'antd';
import PenSelect, { PenSelectValue } from '../PenSelect';
import ToolBtn from '../ToolBtn';
import { ToolTye } from '@/components/Note/utils';
import { getFormatMessage } from '@/utils/locale';
interface ColorProps {
  value: PenSelectValue;
  onChange: (value: PenSelectValue) => void;
  activeType: ToolTye.PEN | ToolTye.PEN_MARKR;
}

export const ToolIconMap = {
  [ToolTye.PEN]: 'icon-brush',
  [ToolTye.PEN_MARKR]: 'icon-brush31',
};

export const ToolTitleMap = {
  [ToolTye.PEN]: getFormatMessage('pen'),
  [ToolTye.PEN_MARKR]: getFormatMessage('marker'),
};

const list = [ToolTye.PEN, ToolTye.PEN_MARKR];

const Color: React.FC<ColorProps> = (props) => {
  const { value, activeType, onChange } = props;
  const [popOverOpen, setPopOverOpen] = React.useState(false);

  const name = useMemo(() => {
    if (list.includes(value.type)) {
      return ToolIconMap[value.type as keyof typeof ToolIconMap];
    }
    return ToolIconMap[activeType];
  }, [value, activeType]);

  const title = useMemo(() => {
    if (list.includes(value.type)) {
      return ToolTitleMap[value.type as keyof typeof ToolTitleMap];
    }
    return ToolTitleMap[activeType];
  }, [value, activeType]);
  const onPopoverOpen = (visible: boolean) => {
    setPopOverOpen(visible);
  };
  return (
    <Popover
      trigger="click"
      placement="right"
      overlayClassName="oj7YZbAO5p"
      onOpenChange={onPopoverOpen}
      align={{ offset: [-2] }}
      content={<PenSelect value={value} onChange={onChange}></PenSelect>}
    >
      <ToolBtn
        name={name}
        active={list.includes(value.type)}
        title={popOverOpen ? '' : title}
        onClick={() => {
          // 点击菜单图标 就去设置一下默认工具
          // 如果当前值不在画笔类型 返回上一次的内容
          if (list.includes(value.type)) {
            onChange({ type: value.type, pen_width: value.pen_width });
          } else {
            onChange({ type: activeType, pen_width: value.pen_width });
          }
        }}
      ></ToolBtn>
    </Popover>
  );
};

export default Color;
